import React, { useEffect, useState } from 'react';
import styles from './CookieBanner.scss';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-scroll';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
    // console.log('Cookies accepted');
  };

  if (!visible) return null;

  return (
    <div className={styles.CookieBanner}>
      <span className={styles.Title}>
        {t('components.cookieBanner.title')}{' '}
        <a href="https://app.nedvex.ru/policy" target="__blank" className={styles.Link}>
          {t('components.cookieBanner.policyLink')}
        </a>
      </span>

      <button className={styles.Button} onClick={acceptCookies}>
        {t('components.cookieBanner.button')}
      </button>
    </div>
  );
};

export default CookieBanner;



// WEBPACK FOOTER //
// ./src/components/CookieBanner/CookieBanner.js